import onlineCardIcon from "@/assets/icons/payments/card.svg";
import sberPayIcon from "@/assets/icons/payments/sber-pay.svg";
import uponReceiptIcon from "@/assets/icons/payments/upon-receipt.svg";
import sbpIcon from "@/assets/icons/payments/sbp.svg";

export const PAYMENT_METHODS = {
  online_sbp: {
    title: "place.paymentMethods.sbp",
    icon: sbpIcon,
    color: "neutral",
  },
  online_card: {
    title: "place.paymentMethods.card",
    icon: onlineCardIcon,
    color: "blue",
  },
  payment_upon_receipt: {
    title: "place.paymentMethods.uponReceipt",
    icon: uponReceiptIcon,
    color: "purple",
  },
  sber_pay: {
    title: "place.paymentMethods.sberPay",
    icon: sberPayIcon,
    color: "green",
  },
};
